<div class="popup-container">
  <header class="popup-header-container">
    <ng-content select="popup-header, popupHeader, [popupHeader]"></ng-content>
  </header>
  <section class="popup-content-container">
    <ng-content select="popup-content, popupContent, [popupContent]"></ng-content>
  </section>
  <footer class="popup-footer-container">
    <ng-content select="popup-footer, popupFooter, [popupFooter]"></ng-content>
  </footer>
</div>
